import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs';

import { AddressAutocompleteAction } from './address-autocomplete.action';
import { AddressAutocompleteService } from '../../services/address-autocomplete.service';

@Injectable({
  providedIn: 'root',
})
export class AddressAutocompleteEffects {
  constructor(
    private actions$: Actions,
    private addressService: AddressAutocompleteService
  ) {}

  searchAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddressAutocompleteAction.setKeyword),
      switchMap((action) =>
        this.addressService.searchAddress(action.value).pipe(
          map((addressList) => {
            return AddressAutocompleteAction.setAddressList({
              value: addressList,
            });
          })
        )
      )
    )
  );
}
